export const FETCH_AVAILABLE_QUIZZES_REQUEST = 'FETCH_AVAILABLE_QUIZZES_REQUEST';
export const FETCH_AVAILABLE_QUIZZES_SUCCESS = 'FETCH_AVAILABLE_QUIZZES_SUCCESS';
export const FETCH_AVAILABLE_QUIZZES_FAILURE = 'FETCH_AVAILABLE_QUIZZES_FAILURE';
export const START_QUIZ_REQUEST = 'START_QUIZ_REQUEST';
export const START_QUIZ_SUCCESS = 'START_QUIZ_SUCCESS';
export const START_QUIZ_FAILURE = 'START_QUIZ_FAILURE';
export const SUBMIT_QUIZ_REQUEST = 'SUBMIT_QUIZ_REQUEST';
export const SUBMIT_QUIZ_SUCCESS = 'SUBMIT_QUIZ_SUCCESS';
export const SUBMIT_QUIZ_FAILURE = 'SUBMIT_QUIZ_FAILURE';
export const UPDATE_QUIZ_ANSWER = 'UPDATE_QUIZ_ANSWER';
export const FETCH_QUIZ_RESULTS_REQUEST = 'FETCH_QUIZ_RESULTS_REQUEST';
export const FETCH_QUIZ_RESULTS_SUCCESS = 'FETCH_QUIZ_RESULTS_SUCCESS';
export const FETCH_QUIZ_RESULTS_FAILURE = 'FETCH_QUIZ_RESULTS_FAILURE';